import 'moment-hijri';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, DoBootstrap, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutComponent } from './layout/layout.component';
import { ApiService } from './services/apiService/api.service';
import { CommonModule, NgSwitch, TitleCasePipe } from '@angular/common';
import { provideLottieOptions } from 'ngx-lottie';
import { SharedModule } from './shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HeaderComponent } from './layout/header/header.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FooterComponent } from './layout/footer/footer.component';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { UidService, initializeGuid } from './services/commonService/uid.service';
import { MatExpansionModule, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { RegistrationModule } from './modules/registration/registration.module';
import { StepperComponent } from './shared/components/stepper/stepper.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SearchEngineModule } from './modules/search-engine/search-engine.module';
import { LoginProfileComponent } from './shared/components/login-profile/login-profile.component';
import { NewNavigationComponent } from './shared/components/new-navigation/new-navigation.component'
import { ProgressStepperComponent } from './shared/components/progress-stepper/progress-stepper.component';
import { EditFlightSearchComponent } from './shared/components/edit-flight-search/edit-flight-search.component';
import { NewProfileComponent } from './shared/components/new-profile/new-profile.component';
import { SaudiaLogoComponent } from './shared/components/saudia-logo/saudia-logo.component';
import { MatButtonModule } from '@angular/material/button';
import { OutsideClickDirective } from './shared/directive/outside-click.directive';
import { ErrorStateComponent } from './shared/components/error-state/error-state.component';
import { OppsErrorStateComponent } from './shared/components/opps-error-state/opps-error-state.component';
import { InternetErrorStateComponent } from './shared/components/internet-error-state/internet-error-state.component';
import { ToasterNotificationsComponent } from './shared/components/toaster-notifications/toaster-notifications.component';
import { CommonDisplayBinderPipe } from './shared/pipes/common-display-binder.pipe';
import { CurrencyDecimalFormatPipe } from './shared/pipes/currency-decimal-format.pipe';
import { ValidateLoginComponent } from './shared/components/validate-login/validate-login.component';
import { HmacInterceptor } from './core/interceptors/hmac.interceptor';
import { AuthModule, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { PreviousPageCaptureService } from './services/dataLayer/previous-page-capture.service';
import { ContactUpdateDialogComponent } from './shared/components/dialogs/contact-update-dialog/contact-update-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner.component';
import { LoyaltyDashboardModule } from './modules/loyalty-dashboard/loyalty-dashboard.module';
import { ValidateLogoutComponent } from './shared/components/validate-logout/validate-logout.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import player from 'lottie-web';
import { LoginLandingComponent } from './shared/components/login-landing/login-landing.component';
export function playerFactory() {
    return player;
}
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
    imports: [
        AppComponent,
        DashboardModule,
        SearchEngineModule,
        BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        RegistrationModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatCardModule,
        MatButtonModule,
        MatExpansionModule,
        MatDialogModule,
        MatInputModule,
        HttpClientModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatButtonModule,
        ReactiveFormsModule,
        NgSelectModule,
        MatFormFieldModule,
        MatSelectModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatTooltipModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
        }),
        SharedModule.forRoot(),
        // AuthModule.forRoot({
        //     domain: 'sit-id.saudia.com',
        //     clientId: '7gxVKo5o9WTReNJtCxgQs2g4yTUlZtuD',
        //     authorizationParams: {
        //         redirect_uri: window.location.origin + '/validatelogin',
        //         scope: 'openid profile email offline_access create:me:authentication_methods',
        //         ui_locales: 'en',
        //         connection: 'Username-idp-SaudiaB2B',
        //         audience: "https://sit-id.saudia.com/me/"
        //     },
        //     cacheLocation: 'localstorage',
        //     useRefreshTokens: true,
        // })
        AuthModule.forRoot({
            domain: environment.auth0.domain,
            clientId: environment.auth0.clientId,
            authorizationParams: {
                redirect_uri: environment.auth0.redirectUri,
                scope: environment.auth0.scope,
                audience: environment.auth0.audience,
                prompt: environment.auth0.prompt,
                // connection: environment.auth0.connection,
                ui_locales: 'en'
            },
            cacheLocation: 'localstorage',
            useRefreshTokens: true
        }),
        MatProgressSpinnerModule,
        MatIconModule,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatMenuModule,
        NgSwitch,
        LayoutComponent,
        HeaderComponent,
        FooterComponent,
        StepperComponent,
        ProgressStepperComponent,
        NewNavigationComponent,
        EditFlightSearchComponent,
        LoginProfileComponent,
        NewProfileComponent,
        SaudiaLogoComponent,
        ErrorStateComponent,
        OppsErrorStateComponent,
        InternetErrorStateComponent,
        OutsideClickDirective,
        ToasterNotificationsComponent,
        ValidateLoginComponent,
        LoginLandingComponent,
        ContactUpdateDialogComponent,
        CookieBannerComponent,
        ValidateLogoutComponent
    ],
    providers: [
        TitleCasePipe,
        PreviousPageCaptureService,
        ApiService,
        UidService,
        CommonDisplayBinderPipe,
        CurrencyDecimalFormatPipe,
        provideLottieOptions({
            player: () => player,
        }),
        { provide: APP_INITIALIZER, useFactory: initializeGuid, deps: [UidService], multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true
        },
        // HMAC Interceptor
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HmacInterceptor,
            multi: true
        },
    ],
    exports: [OutsideClickDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule implements DoBootstrap {
  ngDoBootstrap(appRef: ApplicationRef) {
    appRef.bootstrap(AppComponent);
  }
}
